export default __webpack_public_path__ + "static/funders-packard-ed736c92d0ff8ef25f8e598cacc688ff.png";